// Libraries
import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {translate} from 'react-i18next';
import {bindActionCreators} from 'redux';
import config from 'config';
import Page from 'src/model/page';


const _ = require('lodash');

// Redux
import * as searchActions from '@getgo/webinar.com-frontend-redux/lib/shared/actions/search';
import * as headerActions from '@getgo/webinar.com-frontend-redux/lib/shared/actions/header';
import * as footerActions from '@getgo/webinar.com-frontend-redux/lib/shared/actions/footer';
import * as launchDarklyActions from '@getgo/webinar.com-frontend-redux/lib/web/actions/launch-darkly';

// Components
import NoSearchResults from 'components/search/no-search-results';
import SearchResultCard from 'components/search/search-result-card';
import { SearchPageSkeleton } from 'components/search/search-page-skeleton';

// Helpers
import * as mixpanelTracker from 'app-lib/mixpanel/mixpanelTracker';
import PageTracker from 'app-lib/helpers/page-tracker';

export class SearchContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            searchQuery: this.getSearchQuery(this.props),
            lastPage: PageTracker.lastPage,
            mixPanelFired: false,
            showSkeleton: true
        };
    }

    componentDidMount() {
        this.setHeader();
        this.setFooter();
        if (!this.props.search.searchResults.totalNumOfResults && !this.props.search.isFetchingSearchResults) {
            this.props.getSearchResults(this.state.searchQuery);
        }
        this.scrollToYPosition();
        PageTracker.lastPage = Page.SEARCH_RESULTS;
    }

    componentWillReceiveProps(nextProps) {
        if (!_.isEqual(nextProps.search.searchResults, this.props.search.searchResults)) {
            this.setHeader();
            this.setFooter();
        }
        if (!_.isEqual(nextProps.location, this.props.location)) {
            this.setState({searchQuery: this.getSearchQuery(nextProps)});
        }
        if (this.props.search.searchId !== nextProps.search.searchId) {
            this.setState({mixPanelFired: false, showSkeleton: true});
        }
        this.mixPanelSearch(nextProps.search.searchId, this.getSearchQuery(nextProps), this.state.lastPage, nextProps.search.searchResults.totalNumOfResults);
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.searchQuery !== this.state.searchQuery && !this.props.search.isFetchingSearchResults) {
            this.props.getSearchResults(this.state.searchQuery);
        }
    }

    componentWillUnmount() {
        this.props.initHeader();
        this.props.initFooter();
        this.updateScrollPosition();
    }

    getSearchQuery(props) {
        return props.location && props.location.query && props.location.query.q ? props.location.query.q : '';
    }

    setHeader() {
        this.props.initHeader({
            navbarBackgroundClasses: 'homepage--nav-background',
            menuItemTextClasses: 'homepage-header-menu-item-text',
            showAlternateLogo: true,
            showSearch: true,
            searchQuery: this.state.searchQuery
        });
    }

    setFooter() {
        this.props.initFooter({
            isActive: true,
            classes: 'generic-page-footer',
            left: <span>{this.props.t('channel.footer.powered')}</span>,
            right: [
                <span id="terms&conditions" key="terms&conditions">
                    <a href={`${config.company.termsOfService}`} target="_blank" rel="noopener">
                        {this.props.t('channel.footer.tnc')}
                    </a>
                </span>,
                <span key="privacy">
                    <a href={`${config.company.privacyPolicy}`} target="_blank" rel="noopener">
                        {this.props.t('channel.footer.privacy')}
                    </a>
                </span>,
                <span key="rights">
                    {this.props.t('channel.footer.copyright')} {this.props.t('channel.footer.company')}
                </span>
            ]
        });
    }

    updateScrollPosition() {
        const scrollPosition = document.documentElement.scrollTop || document.body.scrollTop;
        this.props.updateScrollPosition(scrollPosition);
    }

    displaySearchResults() {
        return this.props.search.searchResults.results.map(result => {
            return <SearchResultCard result={result} searchId={this.props.search.searchId} />;
        });
    }

    mixPanelSearch(searchId, searchQuery, lastPage, numResults) {
        if (searchId && searchQuery && lastPage && numResults && !this.state.mixPanelFired) {
            mixpanelTracker.track(`${mixpanelTracker.searchPage}-${mixpanelTracker.newSearch}`, {
                search_id: searchId,
                query: searchQuery,
                page: lastPage,
                results_quantity: numResults
            });
            this.setState({mixPanelFired: true});
        }
    }

    mixPanelLoadMore() {
        mixpanelTracker.track(`${mixpanelTracker.searchPage}-${mixpanelTracker.loadMore}`, {
            search_id: this.props.search.searchId,
            query: this.props.search.searchQuery,
            type: mixpanelTracker.searchPage,
            page: this.props.search.pageNumber + 1
        });
    }

    showLoadMoreDiv(shouldShowLoadMore) {
        const {t} = this.props;
        return (
            <div className="search--container-load-btn">
            {shouldShowLoadMore &&
                <div
                  className="content-card-container__load-more search--container-load-more animated fadeIn"
                  onClick={this.loadMoreClicked.bind(this)}
                >
                    {t('button.load-more')}
                </div>}
            </div>
        );
    }

    loadMoreClicked() {
        this.mixPanelLoadMore();
        this.setState({showSkeleton: false});
        const clearSearchResults = false;
        this.props.getSearchResults(this.state.searchQuery, this.props.search.pageNumber + 1, clearSearchResults);
    }

    scrollToYPosition() {
        if (!this.props.search.isLoading && this.props.search.scrollPositionY) {
            window.scrollTo(0, this.props.search.scrollPositionY);
        }
    }

    renderNumberOfResults(numOfResults) {
        const {t} = this.props;
        return (
            <div className="search--num-results-div">
                {numOfResults} {t('search.event')}{numOfResults > 1 && 's'} {t('search.found')}
            </div>
        );
    }

    renderSearchQuery() {
        return (
            <div className="search--query-div">
                {this.state.searchQuery}
            </div>
        );
    }

    displaySearchData() {
        const { search } = this.props;
        const totalNumOfResults = search.searchResults && search.searchResults.totalNumOfResults ? search.searchResults.totalNumOfResults : 0;
        const shouldShowLoadMore = search.searchResults.hasMore || false;
        if (search && search.searchResults && totalNumOfResults > 0) {
            return (
                <div>
                    <div className="search--container-data animated fadeIn">
                      {this.mixPanelSearch()}
                      {this.renderSearchQuery()}
                      {this.renderNumberOfResults(totalNumOfResults)}
                    </div>
                    {this.displaySearchResults()}
                    {this.showLoadMoreDiv(shouldShowLoadMore)}
                </div>
            );
        }
        return null;
    }

    displayNoSearchData() {
        const { search } = this.props;
        if (search.searchResults && search.searchResults.totalNumOfResults === 0) {
            return <NoSearchResults searchQuery={search.searchQuery} searchId={search.searchId} />;
        }
        return null;
    }

    displaySearchError() {
        const { search } = this.props;
        return (search.error) ? <NoSearchResults isSearchError={true} /> : null;
    }

    showSkeleton() {
        const { search, isFetchingMetadata } = this.props;
        return (this.state.showSkeleton && (isFetchingMetadata && !(search.searchResults && search.searchResults.totalNumOfResults === 0)));
    }

    render() {
        if (!this.props.launchDarkly.search.enableSearch) {
            return (
                <section className="search--container">
                </section>
            );
        }
        return (
            <section className="search--container">
                {this.showSkeleton() ? <SearchPageSkeleton /> : this.displaySearchData()}
                {this.displayNoSearchData()}
                {this.displaySearchError()}
            </section>
        );
    }
}

SearchContainer.propTypes = {
    search: PropTypes.object,
    location: PropTypes.object,
    launchDarkly: PropTypes.object,
    getSearchResults: PropTypes.func,
    updateScrollPosition: PropTypes.func,
    isFetchingMetadata: PropTypes.bool,
    t: PropTypes.func,
    initHeader: PropTypes.func,
    initFooter: PropTypes.func
};

export default connect(state => ({
    search: state.search,
    enableSearch: state.launchDarkly.search.enableSearch,
    isFetchingMetadata: !state.search.metadataResolve
}), dispatch => bindActionCreators(Object.assign({}, searchActions, headerActions, footerActions, launchDarklyActions), dispatch)
)(translate(['translation'])(SearchContainer));



// WEBPACK FOOTER //
// ./src/components/search/search-container.js